export var EAppActions;
(function (EAppActions) {
    /* -------------------------------------------------------------------------------------------------
     * App
     * -----------------------------------------------------------------------------------------------*/
    EAppActions["CONNECT_WALLET_OPEN"] = "CONNECT_WALLET_OPEN";
    EAppActions["SET_ERROR_REPORTING"] = "SET_ERROR_REPORTING";
    EAppActions["SET_WRONG_NETWORK_OPEN"] = "SET_WRONG_NETWORK_OPEN";
    EAppActions["SET_CLIENT_SETTINGS"] = "SET_CLIENT_SETTINGS";
})(EAppActions || (EAppActions = {}));
//# sourceMappingURL=types.js.map